import { render, staticRenderFns } from "./AdditionalManager.vue?vue&type=template&id=575964ac&scoped=true"
import script from "./AdditionalManager.vue?vue&type=script&lang=js"
export * from "./AdditionalManager.vue?vue&type=script&lang=js"
import style0 from "./AdditionalManager.vue?vue&type=style&index=0&id=575964ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575964ac",
  null
  
)

export default component.exports